import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	titleNonFinal: {
		id: 'eoc-changeboarding.wizard.optimal.steps.five.content.first-unlocked-admin.title-non-final',
		defaultMessage: "We're now moving you to Jira Service Management",
		description: 'Title for the first unlocked admin content for the optimal wizard',
	},
	description1NonFinal: {
		id: 'eoc-changeboarding.wizard.optimal.steps.five.content.first-unlocked-admin.description-1-non-final',
		defaultMessage:
			'Almost all of your Opsgenie data and settings are now in Jira Service Management.',
		description: 'First description for the first unlocked admin content for the optimal wizard',
	},
	description2NonFinal: {
		id: 'eoc-changeboarding.wizard.optimal.steps.five.content.first-unlocked-admin.description-2-non-final',
		defaultMessage:
			"Let's go finish setting up some critical configurations, so your teams can start using operations in Jira Service Management.",
		description: 'Second description for the first unlocked admin content for the optimal wizard',
	},
});
